function momenyFormat(num) {
  num = Number(num);
  if (isNaN(num)) return "0.00";
  return num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
}
/**
 * 文本过长截断并显示省略号（三个点）
 * 示例 1：单行按字符数截断（最常用）  const shortText = truncateText(longText, { maxLength: 10 });
 * 示例 2：单行按容器宽度截断 const shortText2 = truncateText(text2, {  maxLines: 1, 
    containerWidth: 300 
   });
   
 * 示例 3：多行截断（2 行） const shortText3 = truncateText(text3, { maxLines: 2, lineHeight: 20, containerWidth: 300 });
   
 * 示例 4：中英文混合，保留完整单词 const shortText4 = truncateText(text4, {  maxLength: 8, keepWord: true  });
   
 * @param {string} text - 原始文本
 * @param {object} options - 配置项
 * @param {number} [options.maxLength] - 单行最大字符数（优先级高于 maxLines，设置后按字符数截断）
 * @param {number} [options.maxLines=1] - 最大显示行数（需配合 lineHeight/containerWidth 计算）
 * @param {number} [options.lineHeight=20] - 行高（px，计算多行时必填）
 * @param {number} [options.containerWidth=200] - 容器宽度（px，计算多行时必填）
 * @param {boolean} [options.keepWord=true] - 是否保留完整单词（中英文混合时，避免截断单词）
 * @returns {string} 截断后的文本
 */
function truncateText(text, options = {}) {
  // 默认配置
  const {
    maxLength,
    maxLines = 1,
    lineHeight = 20,
    containerWidth = 200,
    keepWord = true,
  } = options;

  // 边界处理：空文本/非字符串直接返回
  if (!text || typeof text !== "string") return "";

  // 场景1：指定单行最大字符数（最常用）
  if (maxLength !== undefined) {
    // 中英文字符长度统一计算（中文算1个，英文/数字算0.5个，更贴合视觉）
    const getCharLength = (str) => {
      let length = 0;
      for (let i = 0; i < str.length; i++) {
        const char = str.charAt(i);
        // 中文/全角字符算1个，英文/半角算0.5个
        length += /[\u4e00-\u9fa5|\u3000-\u303f|\uff00-\uffef]/.test(char)
          ? 1
          : 0.5;
      }
      return length;
    };

    // 文本长度未超，直接返回
    if (getCharLength(text) <= maxLength) return text;

    // 截断文本（保留完整单词）
    let truncated = "";
    let currentLength = 0;
    for (let i = 0; i < text.length; i++) {
      const char = text.charAt(i);
      const charLen = /[\u4e00-\u9fa5|\u3000-\u303f|\uff00-\uffef]/.test(char)
        ? 1
        : 0.5;

      // 超过长度则停止
      if (currentLength + charLen > maxLength) {
        // 保留完整单词：如果是英文单词，回退到空格处
        if (keepWord && /[a-zA-Z]/.test(char) && i > 0) {
          const lastSpaceIndex = truncated.lastIndexOf(" ");
          if (lastSpaceIndex > 0) {
            truncated = truncated.substring(0, lastSpaceIndex);
          }
        }
        break;
      }
      truncated += char;
      currentLength += charLen;
    }
    return truncated + "...";
  }

  // 场景2：按行数截断（需计算每行可显示字符数）
  if (maxLines === 1) {
    // 单行：按容器宽度计算可显示字符数（简化版，按平均字符宽度）
    const avgCharWidth = 10; // 平均字符宽度（px）
    const maxCharPerLine = Math.floor(containerWidth / avgCharWidth);
    return text.length > maxCharPerLine
      ? text.substring(0, maxCharPerLine) + "..."
      : text;
  }

  // 多行：计算总可显示字符数（按行高和容器宽度）
  const avgCharWidth = 10;
  const maxCharPerLine = Math.floor(containerWidth / avgCharWidth);
  const totalMaxChar = maxCharPerLine * maxLines;

  if (text.length <= totalMaxChar) return text;

  // 截断并补省略号
  let truncated = text.substring(0, totalMaxChar - 3); // 预留3个字符给省略号
  // 保留完整单词
  if (keepWord && /[a-zA-Z]/.test(text[totalMaxChar - 3])) {
    const lastSpaceIndex = truncated.lastIndexOf(" ");
    if (lastSpaceIndex > 0) {
      truncated = truncated.substring(0, lastSpaceIndex);
    }
  }
  return truncated + "...";
}
/**
 * 筛选数组中指定字段都不为空的对象
 * @param {Array} arr - 要筛选的数组
 * @param {Array} fields - 需要检查的字段列表
 * @returns {Array} 包含指定字段都不为空的对象的新数组
 * // 使用示例
const arr = [
    {
        comboName: "",
        saleNum: "",
        type: 2,
        typeList1: [],
        typeList2: new Array(36),
        typeList3: [],
        typeName: "午餐",
        unit: "",
        unitName: ""
    },
    {
        comboName: "TAOCAN1",
        saleNum: "22",
        type: 2,
        typeList1: [],
        typeList2: new Array(36),
        typeList3: [],
        typeName: "午餐",
        unit: "",
        unitName: ""
    }
];

// 筛选 comboName 和 saleNum 都不为空的对象
const result = filterNonEmptyFields(arr, ['comboName', 'saleNum']);
console.log(result); 
// 输出：[{ comboName: "TAOCAN1", saleNum: "22", ... }]
// 只返回第二个对象，因为它的两个字段都有值
 */
function filterNonEmptyFields(arr, fields) {
  // 检查输入是否有效
  if (!Array.isArray(arr) || !Array.isArray(fields) || fields.length === 0) {
    return [];
  }

  // 筛选出指定字段全部不为空的对象
  return arr.filter((item) => {
    // 检查当前对象的所有指定字段是否都不为空
    return fields.every((field) => {
      // 字段不存在视为空
      if (!Object.prototype.hasOwnProperty.call(item, field)) {
        return false;
      }
      const value = item[field];
      // 不为空的条件：不是空字符串、不是null、不是undefined
      return value !== "" && value !== null && value !== undefined;
    });
  });
}
// 对象数组去重
function uniqueMultiPropertyArray(arr) {
  const uniqueArr = arr.filter((item, index, self) => {
    return (
      index ===
      self.findIndex(
        (obj) => obj.Id === item.Id && obj.cCusName === item.cCusName,
      )
    );
  });

  return uniqueArr;
}
/**
 * 验证数组及其对象字段是否符合条件
 * @param {Array} arr - 需要验证的数组
 * @param {string|string[]} requiredFields - 必须存在且非空的字段名或字段名数组
 * @param {string|string[]} [nonEmptyObjectFields=[]] - 必须为非空对象的字段名或字段名数组
 * @param {boolean} [strictEmpty=true] - 是否严格检查空值（包括0、false等有意义的值）
 * @returns {boolean} - 所有条件满足返回true，否则返回false
 
 
 // 示例用法
 const listItem = [
   {
     comboCode: "",      // 空
     foodCode: "CP250724968",
     foodDish: {},       // 空对象
     foodId: 126,
     foodName: "",       // 空
     type: "2",
     typeName: "配菜"
   },
   {
     comboCode: "",      // 空
     foodCode: "CP250724968",
     foodDish: {},       // 空对象
     foodId: 126,
     foodName: "",       // 空
     type: "2",
     typeName: "配菜"
   }
 ];
 
 // 验证foodCode和type字段非空
 console.log(validateArray(listItem, ["foodCode", "type"])); // true
 
 // 验证foodCode和foodName字段非空（foodName为空，返回false）
 console.log(validateArray(listItem, ["foodCode", "foodName"])); // false
 
 // 验证foodDish是否为非空对象（foodDish是空对象，返回false）
 console.log(validateArray(listItem, ["foodCode"], ["foodDish"])); // false
 
 // 宽松模式：0不视为空
 console.log(validateArray([{ count: 0 }], "count", [], false)); // true
 */

function validateArrayFields(
  arr,
  requiredFields,
  nonEmptyObjectFields = [],
  strictEmpty = true,
) {
  // 检查数组是否存在或为空
  if (!arr || arr.length === 0) {
    return false;
  }

  // 将单个字段名转换为数组
  const requiredList = Array.isArray(requiredFields)
    ? requiredFields
    : [requiredFields];
  const nonEmptyObjList = Array.isArray(nonEmptyObjectFields)
    ? nonEmptyObjectFields
    : [nonEmptyObjectFields];

  // 遍历数组中的每个对象
  for (const obj of arr) {
    // 检查必需字段是否存在且非空
    for (const field of requiredList) {
      const value = obj[field];

      // 判断字段是否为空
      const isEmpty = strictEmpty
        ? !value // 严格模式：0、false、''、null、undefined等都视为空
        : value === undefined || value === null || value === ""; // 宽松模式：只检查常见空值

      if (isEmpty) {
        return false; // 任何必需字段为空，验证失败
      }
    }

    // 检查特定字段是否为非空对象
    for (const field of nonEmptyObjList) {
      const value = obj[field];

      // 判断是否为非空对象
      const isValidObject =
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        Object.keys(value).length > 0;

      if (!isValidObject) {
        return false; // 任何对象字段不是非空对象，验证失败
      }
    }
  }

  // 所有条件满足
  return true;
}

/**
let fieldsToCheck = ['comboName','saleNum'];
let result = checkFieldsAndGetIndices(list, fieldsToCheck);
console.log(result);
// 判断数组中每个对象元素里的某一个字段或者某几个字段是否为空，只要有任何一个对象里
的某一个字段或者某几个字段为空就不行，并且返回所有为空的数组下标  */
function checkFieldsAndGetIndices(arr, fields) {
  let emptyIndices = [];
  arr.forEach((obj, index) => {
    let isEmpty = fields.some((field) => {
      const value = obj[field];
      return value === null || value === undefined || value === "";
    });
    if (isEmpty) {
      emptyIndices.push(index);
    }
  });
  return emptyIndices;
}
/**
 * 判断当前时间是否在每周二00:00至周五12:00之间
 * @param {Date} [date] - 可选参数，指定要检查的日期，默认使用当前时间
 * @returns {boolean} - 如果在范围内返回true，否则返回false
 * 
// 使用示例
// console.log("当前是否在范围内：", isInTimeRange());
 */
function isInTimeRange(date) {
  // 使用提供的日期或当前日期
  const currentDate = date ? new Date(date) : new Date();

  // 获取星期几（0=星期日, 1=星期一, ..., 2=星期二, ..., 5=星期五）
  const day = currentDate.getDay();
  // 获取小时数（0-23）
  const hours = currentDate.getHours();
  // 获取分钟数（0-59）
  const minutes = currentDate.getMinutes();
  // 获取秒数（0-59）
  const seconds = currentDate.getSeconds();

  // 周二、周三、周四全天都在范围内
  if (day === 2 || day === 3 || day === 4) {
    return true;
  }

  // 处理周五的情况：仅00:00:00到12:00:00之间
  if (day === 5) {
    // 小时小于12 → 在范围内
    if (hours < 12) {
      return true;
    }
    // 刚好12:00:00也视为在范围内
    if (hours === 12 && minutes === 0 && seconds === 0) {
      return true;
    }
  }

  // 其他情况（周日、周一、周五12:00之后）均不在范围内
  return false;
}
/**
 * 将形如"2025/7/31"的日期格式化为"2025-07-31"格式
 * @param {string} dateString - 输入的日期字符串，格式为YYYY/M/D
 * @returns {string} 格式化后的日期字符串，格式为YYYY-MM-DD
 * // 使用示例
const originalDate = "2025/7/31";
const formattedDate = formatDate(originalDate);
console.log(formattedDate); // 输出: "2025-07-31"
 */
function formatDate(dateString) {
  // 分割日期字符串为年、月、日
  const [year, month, day] = dateString.split("/").map(Number);

  // 确保月份和日期为两位数（不足两位前面补0）
  const formattedMonth = String(month).padStart(2, "0");
  const formattedDay = String(day).padStart(2, "0");

  // 拼接成目标格式
  return `${year}-${formattedMonth}-${formattedDay}`;
}

/**
 * 验证值是否符合指定规则
 * @param {string|number} value - 需要验证的值
 * @param {Object} options - 验证选项配置
 * @param {boolean} [options.allowDecimal=false] - 是否允许小数点
 * @param {number|null} [options.maxLength=null] - 最大允许长度，null表示不限制
 * @param {boolean} [options.allowLetters=false] - 是否允许大小写字母
 * @param {boolean} [options.allowSpecialChars=false] - 是否允许特殊符号
 * @param {boolean} [options.allowChinese=false] - 是否允许汉字
 * @param {boolean} [options.allowZero=true] - 是否允许值为0
 * @returns {Object} 包含验证结果和错误信息的对象
 * 
// 示例用法
const testCases = [
    { 
        value: 0, 
        config: { allowZero: false } 
    },
    { 
        value: "0", 
        config: { allowZero: false }  
    },
    { 
        value: "123.45", 
        config: { allowDecimal: true, maxLength: 10 } 
    },
    { 
        value: "Hello123", 
        config: { allowLetters: true } 
    },
    { 
        value: "测试文字", 
        config: { allowChinese: true } 
    },
    { 
        value: "user@12.", 
        config: { allowDecimal:true,allowLetters: true, allowSpecialChars: true } 
    },
    { 
        value: "123456", 
        config: { maxLength: 5 } 
    }
];

// 执行测试
testCases.forEach(({ value, config }, index) => {
    const result = validateValue(value, config);
    console.log(`测试用例 ${index + 1}:`);
    console.log(`值: ${typeof value}类型的"${value}"`);
    console.log(`配置:`, config);
    console.log(`结果:`, result);
    console.log('---');
});
 */
function validateValue(value, options = {}) {
  // 处理原始值，转为字符串便于统一处理
  const originalValue = value;
  const inputStr = String(value);

  // 设置默认选项，新增allowNegative默认值为false
  const {
    allowDecimal = false,
    maxLength = null,
    allowLetters = false,
    allowSpecialChars = false,
    allowChinese = false,
    allowZero = true,
    allowNegative = false, // 新增选项：是否允许负数
  } = options;

  // 检查空值  暂时注释
  // if (inputStr.trim() === '') {
  // 	return {
  // 		valid: false,
  // 		message: '值不能为空'
  // 	};
  // }
  // 检查负数（仅允许开头出现一个减号）
  if (inputStr.includes("-")) {
    // 如果不允许负数，直接返回错误
    if (!allowNegative) {
      return {
        valid: false,
        message: "不允许输入负数",
      };
    }
    // 检查减号是否只出现在开头且只出现一次
    if (inputStr.indexOf("-") !== 0 || inputStr.lastIndexOf("-") !== 0) {
      return {
        valid: false,
        message: "负数格式不正确，减号只能出现在开头且只能有一个",
      };
    }
  }

  // 检查是否为0（包括字符串"0"和数字0）
  if (!allowZero && (originalValue === 0 || inputStr === "0")) {
    return {
      valid: false,
      message: "不允许值为0",
    };
  }
  // 检查前导零（整数部分）
  const integerPart = inputStr.split(".")[0];
  if (integerPart.length > 1 && integerPart.startsWith("0")) {
    return {
      valid: false,
      message: "输入不能包含前导0",
    };
  }

  // 检查长度限制
  if (maxLength !== null && inputStr.length > maxLength) {
    return {
      valid: false,
      message: `长度不能超过${maxLength}个字符`,
    };
  }

  // 定义各类字符的正则表达式
  const regexPatterns = {
    decimal: /\./,
    letter: /[a-zA-Z]/,
    chinese: /[\u4e00-\u9fa5]/,
    // 包含常见特殊符号，可根据需要调整
    specialChar: /[!@#$%^&*(),.?":{}|<>;'/\\[\]`~=+\_\s]/,
    digit: /[0-9]/,
  };

  // 检查每个字符
  for (const char of inputStr) {
    // 数字默认允许（0的整体判断已在前面处理）
    if (regexPatterns.digit.test(char)) {
      continue;
    }

    // 检查小数点
    if (regexPatterns.decimal.test(char)) {
      if (!allowDecimal) {
        return {
          valid: false,
          message: "不允许包含小数点",
        };
      }
      continue;
    }

    // 检查字母
    if (regexPatterns.letter.test(char)) {
      if (!allowLetters) {
        return {
          valid: false,
          message: "不允许包含字母",
        };
      }
      continue;
    }

    // 检查汉字
    if (regexPatterns.chinese.test(char)) {
      if (!allowChinese) {
        return {
          valid: false,
          message: "不允许包含汉字",
        };
      }
      continue;
    }

    // 检查特殊符号
    if (regexPatterns.specialChar.test(char)) {
      if (!allowSpecialChars) {
        return {
          valid: false,
          message: `不允许包含特殊符号: ${char}`,
        };
      }
      continue;
    }

    // 未识别的字符
    if (!allowNegative)
      return {
        valid: false,
        message: `不允许包含字符: ${char}`,
      };
  }

  return {
    valid: true,
    message: "验证通过",
  };
}
// 封装函数：返回指定位数的字符串
// 参数：str-原始字符串，length-指定的长度
// 功能：如果原字符串长度小于指定长度，补空格；如果大于，截断
// 使用示例
// console.log(getSpecifiedLengthString("hello", 10)); // "hello     "
// console.log(getSpecifiedLengthString("hello world", 5)); // "hello"
// console.log(getSpecifiedLengthString("test", 4)); // "test"
function getSpecifiedLengthString(str, length) {
  // 检查输入是否为字符串
  if (typeof str !== "string") {
    throw new Error("第一个参数必须是字符串");
  }

  // 检查长度是否为正整数
  if (typeof length !== "number" || length <= 0 || !Number.isInteger(length)) {
    throw new Error("第二个参数必须是正整数");
  }

  // 如果字符串长度小于指定长度，补空格
  if (str.length < length) {
    return str.padEnd(length, " ");
  }
  // 如果字符串长度大于等于指定长度，截断
  else {
    return str.substring(0, length);
  }
}

/**
 * 验证字段是否为空 * @param {string} value - 需要验证的值
 * @param {string} value - 传入的值
 * @param {string} fieldName - 传入的字段名
 *
 */
function checkEmpty(value, fieldName) {
  // 处理空值情况：null、undefined、空字符串（含仅空格的字符串）
  const isEmpty =
    value === null || value === undefined || String(value).trim() === "";

  if (isEmpty) {
    return {
      isEmpty: false,
      message: `请输入${fieldName}`,
    };
  }

  return {
    isEmpty: true,
    message: "",
  };
}

/**
 * 验证手机号、邮箱、银行卡号或联行号格式 * @param {string} value - 需要验证的值
 * @param {string} type - 验证类型：'phone'|'email'|'bankCard'|'bankBranch'
 * @returns {Object} 验证结果
 *   - isValid: boolean - 是否通过验证
 *   - error: string - 错误信息（空字符串表示无错误）
 * @throws {Error} 当类型参数无效时抛出错误
 * // 使用示例
console.log(validateFormat('13800138000', 'phone'));
// { isValid: true, error: "" }

console.log(validateFormat('test@example.com', 'email'));
// { isValid: true, error: "" }

console.log(validateFormat('6222021234567890123', 'bankCard'));
// { isValid: true, error: "" }

console.log(validateFormat('102100099999', 'bankBranch'));
// { isValid: true, error: "" }

// 无效案例
console.log(validateFormat('1234567890', 'phone'));
// { isValid: false, error: "请输入有效的手机号（11位数字，以1开头）" }

console.log(validateFormat('invalid-email', 'email'));
// { isValid: false, error: "请输入有效的邮箱地址（如：example@domain.com）" }

console.log(validateFormat('123456', 'bankCard'));
// { isValid: false, error: "请输入有效的银行卡号（16-19位数字）" }
 */
function validateFormat(value, type) {
  // 处理空值情况
  const strValue = String(value).trim();
  // if (strValue === '' || value === null || value === undefined) {
  //     return {
  //         isValid: false,
  //         error: '输入不能为空'
  //     };
  // }

  // 定义验证规则映射表
  const validators = {
    // 手机号验证：中国大陆手机号，11位数字，以1开头，第二位为3-9
    phone: {
      regex: /^1[3-9]\d{9}$/,
      error: "请输入有效的手机号（11位数字，以1开头）",
    },
    // 邮箱验证：支持字母、数字、特殊字符及多级域名
    email: {
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      error: "请输入有效的邮箱地址（如：example@domain.com）",
    },
    // 银行卡号验证：16-19位数字（涵盖大多数银行的卡号长度）
    supplierBankNumber: {
      regex: /^\d{16,19}$/,
      error: "请输入有效的银行卡号（16-19位数字）",
    },
    // 联行号验证：12位数字（银行联行号固定长度）
    supplierInterBank: {
      regex: /^\d{12}$/,
      error: "请输入有效的联行号（12位数字）",
    },
    // 统一社会信用代码验证：18位，包含数字、大写字母
    supplierCode: {
      regex: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
      error: "请输入有效的统一社会信用代码（18位字符，含数字和大写字母）",
    },
  };

  // 验证类型是否有效
  if (!validators.hasOwnProperty(type)) {
    throw new Error(
      "无效的验证类型，可选类型：phone、email、bankCard、bankBranch",
    );
  }

  // 执行验证
  const { regex, error } = validators[type];
  if (regex.test(strValue)) {
    return {
      isValid: true,
      error: "",
    };
  } else {
    return {
      isValid: false,
      error,
    };
  }
}

/**
 * 根据传入的日期判断是星期几
 * @param {Date|string|number} date - 日期，可以是Date对象、日期字符串或时间戳
 * @returns {Object} 包含星期几数字和名称的对象
 * // 示例用法
const testDates = [
    new Date(),                  // 当前日期
    '2023-10-01',                // 字符串日期（国庆节）
    '2024-02-10',                // 字符串日期
    1710000000000,               // 时间戳
    'invalid-date',              // 无效日期
    999999999999999999999        // 无效时间戳
];

// 测试并输出结果
testDates.forEach((date, index) => {
    const result = getDayOfWeek(date);
    console.log(`测试用例 ${index + 1}:`);
    console.log(`输入:`, date);
    console.log(`结果:`, result);
    console.log('---');
});
 */
function getDayOfWeek(date) {
  // 处理不同类型的日期输入
  let targetDate;

  if (date instanceof Date) {
    // 如果是Date对象，直接使用
    targetDate = date;
  } else if (typeof date === "string" || typeof date === "number") {
    // 如果是字符串或数字，尝试转换为Date对象
    targetDate = new Date(date);
  } else {
    return {
      success: false,
      error: "无效的日期格式，请传入Date对象、日期字符串或时间戳",
    };
  }

  // 检查日期是否有效
  if (isNaN(targetDate.getTime())) {
    return {
      success: false,
      error: "无法解析为有效的日期",
    };
  }

  // 获取星期几（0表示星期日，6表示星期六）
  const dayNumber = targetDate.getDay();

  // 星期名称映射表
  const dayNames = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

  return {
    success: true,
    dayNumber: dayNumber, // 数字形式（0-6）
    dayName: dayNames[dayNumber], // 中文名称
    date: targetDate.toLocaleDateString(), // 格式化的日期字符串
  };
}

function mergeArrays(arr1, key1, insertKey, arr2, key2) {
  // 遍历数组2中的每个元素
  return arr2.map((item2) => {
    // 在数组1中查找符合条件的元素（key1值与key2值相等）
    const matchedItem = arr1.find((item1) => item1[key1] === item2[key2]);
    // 如果找到匹配元素，将数组1的insertKey字段插入数组2的元素中
    if (matchedItem) {
      return {
        ...item2,
        [insertKey]: matchedItem[insertKey],
      };
    }
    // 未找到匹配元素则返回原元素
    return item2;
  });
}
function isEmptyObject(obj) {
  return (
    typeof obj === "object" && obj !== null && JSON.stringify(obj) === "{}"
  );
}

/**
 * 根据index字段查找菜单对象，若有children则合并子项属性到主对象
 * @param {Array} menuItems - 菜单数组
 * @param {string} targetIndex - 要查找的index值
 * @returns {Object|null} 处理后的菜单对象或null
 */
function findAndMergeMenuItem(menuItems, targetIndex) {
  // 检查输入是否为有效的数组
  if (!Array.isArray(menuItems)) {
    console.error("menuItems必须是一个数组");
    return null;
  }

  // 递归查找函数
  function search(items) {
    for (const item of items) {
      // 找到匹配的index
      if (item.index === targetIndex) {
        // 复制对象以避免修改原数据
        const result = { ...item };

        // 如果有children字段且是数组
        if (
          result.children &&
          Array.isArray(result.children) &&
          result.children.length > 0
        ) {
          // 合并第一个子项的属性（如果有多个子项，这里只合并第一个）
          const firstChild = result.children[0];
          Object.keys(firstChild).forEach((key) => {
            // 只合并主对象中不存在的属性
            if (!(key in result)) {
              result[key] = firstChild[key];
            }
          });

          // 移除children属性
          delete result.children;
        }

        return result;
      }

      // 如果有children，递归查找子菜单
      if (item.children && Array.isArray(item.children)) {
        const found = search(item.children);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  return search(menuItems);
}
/**
 * 确定值是否为数组
 *
 * @param {Object} val 传入的值
 * @returns {boolean} 如果值是数组，则为True，否则为false
 */
function isArray(val) {
  return Object.prototype.toString.call(val) === "[object Array]";
}
/**
 * 确定值是否为对象
 *
 * @param {Object} obj 传入的对象
 * @returns {String} 返回类型
 */
function getObjClass(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1);
}
/**
 * 深度克隆
 *
 * @param {Object} obj 传入需要克隆的对象
 * @returns {Object} 返回克隆好的对象
 */
function deepClone(obj) {
  let result;
  let objClass = this.getObjClass(obj);

  if (objClass === "Object") {
    result = {};
  } else if (objClass === "Array") {
    result = [];
  } else {
    return obj; // 如果是其他数据类型不复制，直接将数据返回
  }

  // 遍历目标对象
  for (let key in obj) {
    let value = obj[key];
    result[key] = this.deepClone(value);
  }

  return result;
}
/**
 * 循环对象
 *
 * @param {Object|Array} obj 传入的值
 * @param {Function} fn 为每个项调用的回调
 */
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") return;

  // 如果还没有可写的东西，就强制一个数组
  if (typeof obj !== "object") obj = [obj];

  if (this.isArray(obj)) {
    // 数组循环
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // 对象循环
    for (var key in obj) {
      /* 是否具有键 */
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
/**
 * 转换菜单数据结构
 * @param {Array} data - 原始菜单数据
 * @param {string} parentIndex - 父菜单索引（用于子菜单索引拼接）
 * @returns {Array} 转换后的 menuItems
 */
// 图标映射表（根据目标格式的 icon 规则配置）
const iconMap = {
  首页: "icon-shouye",
  公众号管理: "icon-gongzhonghaoguanli",
  // 可根据需要补充其他菜单的图标映射
  模板: "icon-a-moban2",
  模块: "icon-mokuaiyingyong",
  轮播: "icon-lunbo-03",
  推文: "icon-fabudankuang-tuiwen",
  AI: "icon-ait",
  商城管理: "icon-shangchengguanli",
};
function transformMenuData(data, parentIndex = "") {
  return (
    data
      // 过滤 hidden 为 true 的菜单（如果需要显示则去掉该过滤）
      .filter((item) => !item.hidden)
      .map((item, childIndex) => {
        // 生成索引：父索引 + 自身索引（如 "7-1"）
        const currentIndex = parentIndex
          ? `${parentIndex}-${item.index}`
          : item.index.toString();

        // 构建基础菜单结构
        const menuItem = {
          index: currentIndex,
          // 只有非 ParentView 组件才保留 componentName（父菜单不需要）
          ...(item.componentName !== "ParentView" && {
            componentName: item.componentName,
          }),
          meta: {
            title: item.meta.title,
            // 从映射表取图标，没有则为空字符串（目标格式中子菜单图标为空）
            icon: iconMap[item.meta.title] || "",
          },
        };

        // 递归处理子菜单（如果有 children）
        if (item.children && item.children.length > 0) {
          menuItem.children = transformMenuData(item.children, currentIndex);
        }

        return menuItem;
      })
  );
}

// 过滤moduleIndex的children字段
function filterModuleIndexChildren(menuList) {
  return menuList.map((item) => {
    // 创建新对象以避免直接修改原数据
    const newItem = { ...item };

    // 检查是否是moduleIndex，如果是则移除children字段
    if (newItem.componentName === "moduleIndex" && newItem.children) {
      delete newItem.children;
    }

    // 递归处理子菜单
    if (newItem.children && Array.isArray(newItem.children)) {
      newItem.children = filterModuleIndexChildren(newItem.children);
    }

    return newItem;
  });
}
/**
 * 解析 URL，拆分 ? 后的查询参数和 # 后的哈希值
 * @param {string} url - 待解析的完整 URL
 * @returns {object} - 包含 query（查询参数对象）和 hash（哈希值）的结果
 */
function parseUrlParamsAndHash(url) {
  // 1. 初始化结果对象
  const result = {
    query: {}, // 存储 ? 后的所有参数（键值对）
    hash: "", // 存储 # 后的哈希值
  };

  // 2. 定位 ? 和 # 的索引位置
  const questionMarkIndex = url.indexOf("?"); // ? 的索引（无则为 -1）
  const hashIndex = url.lastIndexOf("#"); // # 的索引（无则为 -1）

  // 3. 提取并解析 # 后的哈希值
  if (hashIndex !== -1) {
    result.hash = url.substring(hashIndex + 1); // 从 # 后一位截取到末尾
  }

  // 4. 提取并解析 ? 后的查询参数（需排除 # 的影响）
  if (questionMarkIndex !== -1) {
    // 确定查询参数的截取范围：从 ? 后一位到 # 前（若有 #），无 # 则到 URL 末尾
    const queryEndIndex = hashIndex !== -1 ? hashIndex : url.length;
    const queryStr = url.substring(questionMarkIndex + 1, queryEndIndex);

    // 拆分查询参数（按 & 分割成键值对字符串，再按 = 分割键和值）
    queryStr.split("&").forEach((item) => {
      const [key, value] = item.split("="); // 例如 "Authorization=xxx" 拆分为 ["Authorization", "xxx"]
      if (key) {
        // 避免空键（如参数末尾多一个 & 的情况）
        result.query[key] = decodeURIComponent(value); // 解码 URL 特殊字符（如中文、符号）
      }
    });
  }

  return result;
}
/**
 * 把后台菜单JSON 转换成 左侧组件库导航格式
 * @param {Object} apiData 后台返回的原始JSON
 * @returns {Array} 你需要的组件库导航格式
 */
function transformListToData(list, options = {}) {
  const result = [];

  // 遍历一级菜单（常规、基础、排版、互动...）
  list.forEach((firstItem, firstIndex) => {
    const group = {
      title: firstItem.meta.title, // 一级菜单标题 → 对应最终 title
      comList: [],
    };

    // 遍历二级菜单（children）
    firstItem.children.forEach((childItem, secondIndex) => {
      group.comList.push({
        text: childItem.meta.title, // meta.title → text
        icon: childItem.meta.icon, // meta.icon → icon
        name: childItem.componentName, // componentName → name
        hidden: childItem.hidden, // hidden → hidden
        type: `${firstIndex + 1}-${secondIndex + 1}`, // 层级 type：1-1、1-2、2-1...
      });
    });

    result.push(group);
  });

  return result;
}
/**
 * 辅助函数：获取对象的嵌套字段值
 * @param {Object} obj - 目标对象
 * @param {string} path - 字段路径（如 'meta.hidden'）
 * @returns {*} 字段值（不存在则返回 undefined）
 */
function getNestedValue(obj, path) {
  if (!obj || typeof path !== "string") return undefined;
  return path.split(".").reduce((current, key) => {
    return current?.[key] !== undefined ? current[key] : undefined;
  }, obj);
}

/**
 * 检测数组中指定对象字段是否包含有效值（通用版）
 * @param {Array} arr - 要检测的数组（每一项需是对象）
 * @param {string} field - 要检测的对象字段名（如 'http'、'url'、'link' 等）
 * @param {Function} [customValidator] - 自定义有效值判断函数（可选）
 * @returns {boolean} - true：存在有效字段值；false：所有字段均无效
 */
function checkFieldHasValidValue(arr, field, customValidator) {
  // 1. 基础参数校验：避免非法输入报错
  if (!Array.isArray(arr)) {
    console.warn("checkFieldHasValidValue：传入的第一个参数必须是数组");
    return false;
  }
  if (typeof field !== "string" || field.trim() === "") {
    console.warn("checkFieldHasValidValue：传入的字段名必须是非空字符串");
    return false;
  }

  // 2. 遍历数组，检测每一项的目标字段
  return arr.some((item) => {
    // 若当前项不是对象/为null，或没有目标字段，直接视为无效
    if (
      !item ||
      typeof item !== "object" ||
      item[field] === undefined ||
      item[field] === null
    ) {
      return false;
    }

    const targetField = item[field]; // 目标字段的值（可能是对象、字符串、数组等）
    const fieldValues =
      typeof targetField === "object"
        ? Object.values(targetField) // 若字段是对象，取其所有属性值
        : [targetField]; // 若字段是基础类型（字符串/数字等），包装成数组统一处理

    // 3. 优先使用自定义验证规则
    if (typeof customValidator === "function") {
      return fieldValues.some((value) => customValidator(value));
    }

    // 4. 默认验证规则：排除 null、undefined、空字符串、空对象、空数组
    return fieldValues.some((value) => {
      // 排除 null/undefined
      if (value === null || value === undefined) return false;
      // 排除空字符串（含纯空格）
      if (typeof value === "string" && value.trim() === "") return false;
      // 排除空对象
      if (
        typeof value === "object" &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0
      )
        return false;
      // 排除空数组
      if (Array.isArray(value) && value.length === 0) return false;
      // 其他情况视为有效（数字、布尔值、非空数组/对象等）
      return true;
    });
  });
}

// 合并函数：以list的字段结构为基准，用list1的值覆盖
/*// 原始数据
// 场景 1：强制把 src 统一设成某张默认图
const result = mergeWithDefaults(
  [],                                                      // 空模板
  [{ id: '1', text: '标题' }, { id: '2', text: '标题2' }], // 需要补字段的数组
  {
    extraKeys: ['id', 'text', 'src'],                     // 手动指定顶层字段
    srcValue: 'https://cdn.example.com/default.png'       // 统一 src 值
  }
);
// 场景 2：不指定 srcValue，维持原逻辑
const result2 = mergeWithDefaults(
  [],
  [{ id: 'x', src: 'already.png' }],
  { extraKeys: ['id', 'src'] }
);
];*/
/**
 * 合并两个数组，并保证第二个数组的每个对象：
 *  1. 包含模板里出现过的全部顶层字段；
 *  2. 若字段为 http 对象，则其内部一定存在 internalLink、externalLink；
 *  3. 缺失字段默认填充空字符串（或自定义值）；
 *  4. 可强制指定 src 字段的值（通过 options.srcValue）。
 *
 * 特殊规则：
 *  如果 templateList 为空数组，则使用用户显式传入的 extraKeys 作为顶层字段清单；
 *  若 extraKeys 也未提供，则默认只补 http 内部字段，其余字段不补。
 *
 * @param {Array<Object>} templateList  模板数组（决定字段清单）
 * @param {Array<Object>} targetList    需要补字段的数组
 * @param {Object} [options]
 * @param {string[]} [options.extraKeys]  当 templateList 为空时，手动指定的顶层字段名数组
 * @param {*} [options.fillValue]         缺失字段的默认值，默认空字符串
 * @param {string} [options.srcValue]     强制给 targetList 中每个对象的 src 字段赋的值
 * @returns {Array<Object>}               合并后的新数组
 */
function mergeWithDefaults(templateList, targetList, options = {}) {
  if (!Array.isArray(templateList) || !Array.isArray(targetList)) {
    throw new TypeError("templateList and targetList must be arrays");
  }

  const { extraKeys = [], fillValue = "", srcValue } = options;

  /* ---------- 1. 收集字段 ---------- */
  const topKeys = new Set();
  const httpKeys = new Set(["internalLink", "externalLink"]);

  if (templateList.length > 0) {
    templateList.forEach((item) => {
      Object.keys(item).forEach((k) => {
        topKeys.add(k);
        if (k === "http" && item[k] && typeof item[k] === "object") {
          Object.keys(item[k]).forEach((hk) => httpKeys.add(hk));
        }
      });
    });
  } else {
    extraKeys.forEach((k) => topKeys.add(k));
  }

  /* ---------- 2. 补全逻辑 ---------- */
  const fixedList = targetList.map((item) => {
    const obj = { ...item };

    // 2.1 补齐顶层字段
    topKeys.forEach((k) => {
      if (!(k in obj)) obj[k] = fillValue;
    });

    // 2.2 强制覆盖 src
    if (srcValue !== undefined) {
      obj.src = srcValue;
    }

    // 2.3 补齐 http 内部字段
    if (!obj.http || typeof obj.http !== "object") {
      obj.http = {};
    }
    httpKeys.forEach((hk) => {
      if (!(hk in obj.http)) obj.http[hk] = fillValue;
    });

    return obj;
  });

  /* ---------- 3. 返回合并 ---------- */
  return [...templateList, ...fixedList];
}
/**
 * 对象数组去重通用方法
 * @param {Array} arr - 待去重的对象数组
 * @param {String|Array} key - 去重依据（单个属性名 | 多个属性名的数组）
 * @param {String} [keep='first'] - 重复项保留规则：first(保留第一个) | last(保留最后一个)
 * @returns {Array} 去重后的新数组
 * // 待去重数组
const userList = [
  { id: 1, name: '张三', age: 20 },
  { id: 2, name: '李四', age: 22 },
  { id: 1, name: '张三', age: 21 }, // 与第一个重复（id相同）
  { id: 3, name: '王五', age: 25 }
];

// 根据id去重，保留第一个
const uniqueById = uniqueObjectArray(userList, 'id');
console.log(uniqueById);
// 输出：[{id:1,name:'张三',age:20}, {id:2,name:'李四',age:22}, {id:3,name:'王五',age:25}]

// 根据id去重，保留最后一个
const uniqueByIdLast = uniqueObjectArray(userList, 'id', 'last');
console.log(uniqueByIdLast);
// 输出：[{id:1,name:'张三',age:21}, {id:2,name:'李四',age:22}, {id:3,name:'王五',age:25}]
 */
function uniqueObjectArray(arr, key, keep = "first") {
  // 校验入参合法性
  if (!Array.isArray(arr) || arr.length === 0) return [];
  if (!key || (Array.isArray(key) && key.length === 0)) return [...arr];

  const cache = new Map(); // 缓存已出现的标识，key为去重标识，value为数组项
  const result = [];

  // 遍历数组，生成唯一标识并去重
  arr.forEach((item) => {
    // 生成去重标识：单个属性取值 | 多个属性拼接
    let identifier;
    if (typeof key === "string") {
      identifier = item[key] ?? ""; // 处理属性值为undefined/null的情况
    } else if (Array.isArray(key)) {
      identifier = key.map((k) => item[k] ?? "").join("_"); // 多属性拼接（用下划线分隔）
    }

    // 根据保留规则处理重复项
    if (!cache.has(identifier)) {
      cache.set(identifier, item);
      result.push(item);
    } else {
      if (keep === "last") {
        // 保留最后一个：删除结果中旧项，添加新项
        const index = result.findIndex((i) => {
          let oldIdentifier;
          if (typeof key === "string") {
            oldIdentifier = i[key] ?? "";
          } else {
            oldIdentifier = key.map((k) => i[k] ?? "").join("_");
          }
          return oldIdentifier === identifier;
        });
        if (index > -1) {
          result.splice(index, 1, item);
        }
      }
    }
  });

  return result;
}
/**
 * 提取v-html里的汉字
 */
function pureChineseText(content) {
  if (!content) return "";
  // 移除HTML标签 → 提取汉字
  const withoutHtml = content.replace(/<[^>]+>/g, "");
  const chineseChars = withoutHtml.match(/[\u4e00-\u9fa5]/g);
  return chineseChars ? chineseChars.join("") : "";
}
/**
 * 按list1的顺序重新排列list2
 * @param {Array} baseList - 基准顺序数组（list1）
 * @param {Array} targetList - 需要重排的数组（list2）
 * @param {String} key - 唯一标识字段（默认id）
 * @returns {Array} 重排后的数组
 */
function reorderListByBase(baseList, targetList, key = "id") {
  // 1. 把targetList转成 {id: 对象} 的映射，方便快速查找
  const targetMap = targetList.reduce((map, item) => {
    map[item[key]] = item;
    return map;
  }, {});

  // 2. 按baseList的顺序，从映射中取出对应元素，组成新数组
  const reorderedList = baseList.map((item) => {
    // 兼容：如果list2中没有对应id的元素，返回原list1的元素（可选）
    return targetMap[item[key]] || item;
  });

  return reorderedList;
}
/**
 * 判断变量是否为空对象（{}）
 * @param {*} obj 要判断的变量
 * @returns {boolean} true=空对象，false=非空对象/非对象
 */
function isEmptyObject(obj) {
  // 步骤1：排除非对象类型（null、数组、函数、数字等）
  if (
    obj === null ||
    typeof obj !== "object" ||
    Array.isArray(obj) ||
    obj instanceof Date ||
    obj instanceof RegExp
  ) {
    return false;
  }

  // 步骤2：检查是否有自身可枚举属性（核心）
  // 方式1：ES5+ 推荐（简洁高效）
  return Object.keys(obj).length === 0;
  // 方式2：兼容极低版本浏览器（ES5 之前），可替换上面一行
  // for (let key in obj) {
  //   if (obj.hasOwnProperty(key)) {
  //     return false;
  //   }
  // }
  // return true;
}
/**
 * 动态修改全局 CSS 变量
 * @param {String} variableName - CSS变量名（不带--）
 * @param {String} value - 要设置的值（如 #FF0000 或 16px）
 */
function setCssVariable(variableName, value) {
  // 获取根元素（:root 对应的就是 html 标签）
  const root = document.documentElement;
  // 设置 CSS 变量，注意变量名要加上--前缀
  root.style.setProperty(`--${variableName}`, value);
}

/**
 * 获取全局 CSS 变量的当前值
 * @param {String} variableName - CSS变量名（不带--）
 * @returns {String} 变量当前值
 */
function getCssVariable(variableName) {
  const root = document.documentElement;
  return getComputedStyle(root).getPropertyValue(`--${variableName}`).trim();
}
// 自定义生成id
function customID(name) {
  return `page_${name}`;
}
// 子集自定义生成id
function customIDChild(parentID, name) {
  return `${parentID}_${name}`;
}

/**
 * 通用的对象字段处理函数
 * @param {Object} customFields - 需要修改/新增的字段（可选，默认空对象）
 * @returns {Object} 处理后的新对象
 */
function handleComponentObj(customFields = {}) {
  const obj = {
    customStyle: customFields.customStyle || {},
    handler: customFields.handler || "handleClickComponent",
    icon: customFields.icon || "",
    id: customFields.id || "", // 先留空，后续动态传
    outline: customFields.outline || true,
    ref: customFields.ref || "", // 先留空，后续动态传
    text: customFields.text || "", // 先留空，后续动态传
    type: customFields.type || "",
  };

  // 返回处理后的对象
  return obj;
}
/**
 * 生成完整的图片路径（固定前缀 + 图片名称）
 * @param {string} imageName - 图片名称（可包含后缀，如"bg.jpg"；若不含后缀会自动补全默认后缀）
 * @param {Object} [options={}] - 配置项
 * @param {string} [options.baseUrl='/static/images/'] - 固定前缀（图片基础路径）
 * @param {string} [options.defaultExt='png'] - 默认图片后缀（当imageName不含后缀时使用）
 * @param {boolean} [options.addTimestamp=false] - 是否添加时间戳（防止缓存，适用于开发环境）
 * @returns {string} 完整的图片路径
 */
function getFullImageUrl(imageName, options = {}) {
  const ossPrefix =
    "https://lingxin1314.oss-cn-beijing.aliyuncs.com/%E6%B5%8B%E8%AF%84%E7%B3%BB%E7%BB%9F/";

  // 默认配置
  const {
    baseUrl = ossPrefix,
    defaultExt = "png",
    addTimestamp = false,
  } = options;

  // 校验图片名称
  if (!imageName || typeof imageName !== "string") {
    console.error("图片名称不能为空且必须为字符串");
    return "";
  }

  // 处理基础路径：确保末尾有 "/"
  const processedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;

  // 处理图片名称：补全后缀（如果没有的话）
  let processedImageName = imageName;
  if (!/\.\w+$/.test(imageName)) {
    // 检查是否包含后缀（如.jpg/.png）
    processedImageName = `${imageName}.${defaultExt}`;
  }

  // 拼接完整路径
  let fullUrl = `${processedBaseUrl}${processedImageName}`;

  // 添加时间戳（防止缓存）
  if (addTimestamp) {
    fullUrl += `${fullUrl.includes("?") ? "&" : "?"}t=${new Date().getTime()}`;
  }

  return fullUrl;
}
/**
 * 智能类型转换：
 * 字符串 true/false → 布尔值
 * 字符串数字 → 数字类型
 * 其他值 → 原样返回
 * @param {any} value - 要转换的值
 * @returns {any} 转换后的值
 */
function strToBool(value) {
  // 如果是 null / undefined 直接返回
  if (value === null || value === undefined) {
    return value;
  }

  // 非字符串类型直接返回（布尔、数字都不处理）
  if (typeof value !== "string") {
    return value;
  }

  const str = value.trim();

  // 1. 处理布尔字符串
  if (str.toLowerCase() === "true") return true;
  if (str.toLowerCase() === "false") return false;

  // 2. 处理数字字符串（整数 + 小数）
  if (!isNaN(str) && str !== "") {
    return Number(str);
  }

  // 3. 普通字符串，不转换
  return str;
}
function handleTree(data, id, parentId, children) {
  // 你的树形数据处理方法
  const config = {
    id: id || "id",
    parentId: parentId || "parentId",
    childrenList: children || "children",
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}
module.exports = {
  momenyFormat,
  uniqueMultiPropertyArray,
  validateArrayFields,
  checkFieldsAndGetIndices,
  isInTimeRange,
  formatDate,
  filterNonEmptyFields,
  validateFormat,
  validateValue,
  getDayOfWeek,
  mergeArrays,
  getSpecifiedLengthString,
  checkEmpty,
  isEmptyObject,
  findAndMergeMenuItem,
  deepClone,
  forEach,
  transformMenuData,
  filterModuleIndexChildren,
  parseUrlParamsAndHash,
  transformListToData,
  customID,
  customIDChild,
  checkFieldHasValidValue,
  setCssVariable,
  getCssVariable,
  reorderListByBase,
  mergeWithDefaults,
  uniqueObjectArray,
  truncateText,
  pureChineseText,
  isEmptyObject,
  handleComponentObj,
  getFullImageUrl,
  strToBool,
  handleTree,
};
